<template>
    <el-card class="box-card" shadow="always">
        <div class="title_btn">
            <div>*客户场景</div>
            <el-button type="primary" @click="addCase">添加场景</el-button>
        </div>

        <el-table v-loading="listLoading" :data="scenceList" border style="width: 100%" align="center" size="mini">
            <el-table-column prop="sort" label="排列序号" align="center" />
            <el-table-column prop="title" label="场景名称" align="center" />
            <el-table-column prop="old_content" label="以前" align="center" />
            <el-table-column label="以前图片" align="center">
                <template slot-scope="scope">
                    <viewer v-if="scope.row.old_img">
                        <img :src="imgDomain + scope.row.old_img" class="viewer-img">
                    </viewer>
                </template>
            </el-table-column>
            <el-table-column prop="old_img_alt" label="以前图片ALT" align="center" />
            <el-table-column prop="new_content" label="现在" align="center" />
            <el-table-column label="现在图片" align="center">
                <template slot-scope="scope">
                    <viewer v-if="scope.row.new_img">
                        <img :src="imgDomain + scope.row.new_img" class="viewer-img">
                    </viewer>
                </template>
            </el-table-column>
            <el-table-column prop="new_img_alt" label="现在图片ALT" align="center" />
            <el-table-column label="操作" align="center">
                <template slot-scope="scope">
                    <el-button type="danger" size="mini" class="op_buttton" @click="showDialog(scope.$index)">删除</el-button>
                </template>
            </el-table-column>
        </el-table>

        <common-dialog title="添加场景" :dialog-visible="dialogVisible" :dialog-width="dialogWidth" @cancel="dialogVisible=false" @confirm="dialogConfirmClick">
            <div class="case_wrap">
                <div class="item">
                    <div class="case-item">
                        <span class="label">*排列序号</span>
                        <el-input-number v-model="scenarios_item.sort" :min="1" clearable class="name-input" placeholder="请输入排列序号" style="width: 100%;" /></el-input-number>
                    </div>

                    <div class="case-item no_right">
                        <span class="label co_w">*场景名称</span>
                        <el-input v-model="scenarios_item.title" clearable class="name-input" placeholder="请输入解决方案名称" />
                    </div>
                </div>

                <div class="item">
                    <div class="case-item">
                        <span class="label">*以前</span>
                        <el-input v-model="scenarios_item.old_content" type="textarea" :autosize="{ minRows: 6, minCols:60}" clearable class="name-input" placeholder="请输入文字描述" />
                    </div>

                    <div class="case-item no_right">
                        <span class="label co_w">*以前-图片</span>
                        <div style="width: 100%;">
                            <imageUpload v-model="scenarios_item.oldImg" :limit="1" />
                            <div class="el-upload__tip">建议尺寸为580*480</div>
                            <el-input v-model="scenarios_item.old_img_alt" clearable class="alt-input" placeholder="请输入自定义ALT（选填）" />
                        </div>
                    </div>
                </div>

                <div class="item">
                    <div class="case-item">
                        <span class="label">*现在</span>
                        <el-input v-model="scenarios_item.new_content" type="textarea" :autosize="{ minRows: 6, minCols:60}" clearable class="name-input" placeholder="请输入文字描述" />
                    </div>

                    <div class="case-item no_right">
                        <span class="label co_w">*现在-图片</span>
                        <div style="width: 100%;">
                            <imageUpload v-model="scenarios_item.newImg" :limit="1" />
                            <div class="el-upload__tip">建议尺寸为580*480</div>
                            <el-input v-model="scenarios_item.new_img_alt" clearable class="alt-input" placeholder="请输入自定义ALT（选填）" />
                        </div>

                    </div>
                </div>
            </div>
        </common-dialog>

        <!-- <div class="page"><pagination v-show="total > 0" :total="total" :page.sync="listQuery.page_index" :limit.sync="listQuery.page_size" @pagination="getList" /></div> -->
    </el-card>
</template>
<script>
import Pagination from '@/components/Pagination';
import { imgDomain } from '@/configs/env';
import imageUpload from '@/components/ImageUpload';
import CommonDialog from '@/components/CommonDialog';
export default {
    components: { Pagination, CommonDialog, imageUpload },
    data() {
        return {
            dialogWidth: "46%",
            imgDomain,
            dialogTitle: "",
            dialogType: "",
            dialogVisible: false,
            total: 0,
            listQuery: {
                page_index: 1,
                page_size: 10
            },
            listLoading: false,
            scenceList: [], // 客户场景列表
            sceneInfo: {},
            scenarios_item: {// 客户场景对象
                sort: "",
                title: "",
                old_content: "",
                new_content: "",
                old_img: "",
                oldImg: [],
                old_img_alt: "",
                new_img: "",
                newImg: [],
                new_img_alt: ""
            }
        };
    },

    watch: {

    },

    // mounted() {
    //     const scenceList = sessionStorage.getItem("scenceList");
    //     if (scenceList) {
    //         this.scenarios_item = JSON.parse(scenceList) ? JSON.parse(scenceList) : [];
    //     }
    // },

    methods: {
        addCase() {
            this.scenarios_item = {
                sort: "",
                title: "",
                old_content: "",
                new_content: "",
                old_img: "",
                oldImg: [],
                old_img_alt: "",
                new_img: "",
                newImg: [],
                new_img_alt: ""
            }
            this.dialogVisible = true;
        },

        showDialog(index) {
            this.$confirm(`是否删除该场景？`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(async() => {
                this.scenceList.splice(index, 1);
                this.$notify({ title: '场景删除成功', type: 'success' });
            }).catch(() => {

            })
        },

        verifyInput() {
            if (!this.scenceList.length) {
                this.$notify.error({ title: '请添加客户场景' });
                return false
            }
            this.sceneInfo.scenarios_item = this.scenceList;
            return true;
        },

        dialogConfirmClick() {
            const { sort, title, old_content, oldImg, old_img_alt, new_content, newImg, new_img_alt } = this.scenarios_item;
            if (!sort) {
                this.$notify.error({ title: '请输入名称排序' });
                return false
            }
            if (!title) {
                this.$notify.error({ title: '请输入场景名称' });
                return false
            }
            if (!old_content) {
                this.$notify.error({ title: '请输入以前场景文字描述' });
                return false
            }
            if (!oldImg.length) {
                this.$notify.error({ title: '请上传以前场景图片' });
                return false
            }
            if (!new_content) {
                this.$notify.error({ title: '请输入现在场景文字描述' });
                return false
            }
            if (!newImg.length) {
                this.$notify.error({ title: '请上传现在场景图片' });
                return false
            }
            this.scenarios_item.old_img = this.scenarios_item.oldImg.join();
            this.scenarios_item.new_img = this.scenarios_item.newImg.join();
            this.scenceList.push(this.scenarios_item);
            this.dialogVisible = false
        }
    }
};
</script>

<style lang="less" scoped>
    .box-card{
        .title_btn{
            div{
                margin-bottom: 20px;
            }
            button{
                margin-bottom: 20px;
            }
        }
        .add{
            float: right;
            margin-bottom: 20px;
        }
        .button_wrap{
            text-align: center;
            margin-top: 30px;
        }
        .el-form-item:last-child{
            margin-bottom: 0;
        }
        .op_buttton{
            margin-bottom: 10px;
        }
        .viewer-img{
            width: 124px;
            height: 100%;
        }
        /deep/ .pagination-container{
            padding-top: 32px;
            padding-bottom:12px;
        }
        .btn_wrap{
            margin-top: 50px;
            text-align: center;
        }
        .case_wrap{
            .item{
               display: flex;
               align-items: center;
               justify-content: space-between;
               margin-bottom: 40px;
            }
            .item:last-child{
                margin-bottom: 0;
            }
            .case-item{
                display: flex;
                align-items: center;
                width: 48%;
                .dankal-image-upload{
                    /deep/ .add-box{
                        padding-left: 0;
                        margin-top: 0;
                        .add{
                            width: 100px;
                            height: 100px;
                        }
                    }
                    /deep/p{
                        width: 100px;
                        height: 100px;
                        margin: 0;
                    }
                }

                .label{
                    width: 80px;
                }
                .co_w{
                    width: 100px;
                }
                /deep/ .el-textarea{
                    width: 100%;
                }
                /deep/ .el-input{
                    width: 100%;
                }
                .alt-input{
                    margin-top: 20px;
                }
            }
            .no_right{
                margin-right: 0;
            }
        }
        .el-upload__tip{
            color: red;
        }
    }
</style>
